module.exports = __webpack_public_path__ + "img/kiosk-counter-top.d3aedf8e.svg";